import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faVk, faOdnoklassnikiSquare, faInstagram, faWhatsapp, faViber } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/*
 * TEMPLATE
 */

import Drawer from '@/components/Drawer'
import Toolbar from '@/components/Toolbar'
import SubToolbar from '@/components/SubToolbar'
import Header from '@/components/Header'
import Footer from '@/components/Footer'

/*
 * PARTIALS
 */

// MALINA
import MalinaButtonCall from '@/components/partials/malina/ButtonCall'
// SADKO
import SadkoButtonCall from '@/components/partials/sadko/ButtonCall'
// ACROPOLIS
import AcropolisButtonCall from '@/components/partials/acropolis/ButtonCall'
//
import ButtonGoBack from '@/components/partials/ButtonGoBack'
import ModalForm from '@/components/partials/ModalForm'

/*
 * SCREENS
 */

// MALINA
import MalinaPlus from '@/components/screens/malina/Plus'
import MalinaServices from '@/components/screens/malina/Services'
import MalinaGallery from '@/components/screens/malina/Gallery'
import MalinaReviews from '@/components/screens/malina/Reviews'
import MalinaContacts from '@/components/screens/malina/Contacts'
// SADKO
import SadkoPlus from '@/components/screens/sadko/Plus'
import SadkoServices from '@/components/screens/sadko/Services'
import SadkoGallery from '@/components/screens/sadko/Gallery'
import SadkoReviews from '@/components/screens/sadko/Reviews'
import SadkoContacts from '@/components/screens/sadko/Contacts'
// ACROPOLIS
import AcropolisPlus from '@/components/screens/acropolis/Plus'
import AcropolisServices from '@/components/screens/acropolis/Services'
import AcropolisGallery from '@/components/screens/acropolis/Gallery'
import AcropolisGalleryCafe from '@/components/screens/acropolis/GalleryCafe'
import AcropolisReviews from '@/components/screens/acropolis/Reviews'
import AcropolisContacts from '@/components/screens/acropolis/Contacts'

library.add(faVk, faOdnoklassnikiSquare, faInstagram, faWhatsapp, faViber)
Vue.component('font-awesome-icon', FontAwesomeIcon)

/*
 * TEMPLATE
 */

Vue.component('app-drawer', Drawer)
Vue.component('app-toolbar', Toolbar)
Vue.component('app-sub-toolbar', SubToolbar)
Vue.component('app-header', Header)
Vue.component('app-footer', Footer)

/*
 * PARTIALS
 */

// MALINA
Vue.component('app-malina-button-call', MalinaButtonCall)
// SADKO
Vue.component('app-sadko-button-call', SadkoButtonCall)
// ACROPOLIS
Vue.component('app-acropolis-button-call', AcropolisButtonCall)
//
Vue.component('app-button-go-back', ButtonGoBack)
Vue.component('app-modal-form', ModalForm)

/*
 * SCREENS
 */

// MALINA
Vue.component('app-malina-plus', MalinaPlus)
Vue.component('app-malina-services', MalinaServices)
Vue.component('app-malina-gallery', MalinaGallery)
Vue.component('app-malina-reviews', MalinaReviews)
Vue.component('app-malina-contacts', MalinaContacts)
// SADKO
Vue.component('app-sadko-plus', SadkoPlus)
Vue.component('app-sadko-services', SadkoServices)
Vue.component('app-sadko-gallery', SadkoGallery)
Vue.component('app-sadko-reviews', SadkoReviews)
Vue.component('app-sadko-contacts', SadkoContacts)
// ACROPOLIS
Vue.component('app-acropolis-plus', AcropolisPlus)
Vue.component('app-acropolis-services', AcropolisServices)
Vue.component('app-acropolis-gallery', AcropolisGallery)
Vue.component('app-acropolis-gallery-cafe', AcropolisGalleryCafe)
Vue.component('app-acropolis-reviews', AcropolisReviews)
Vue.component('app-acropolis-contacts', AcropolisContacts)

Vue.use(Vuetify)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js